// Dependencias generales
import React from "react"
import { useEffect, useState } from 'react'
import '../../css/dashboard.css'
import MainHeaderHELIAS from '../../components/AppLayout/MainHeaderHELIAS'
import FooterHELIAS from '../../components/AppLayout/FooterHELIAS'

import Dashboard from "./Dashboard"
import InstallationConfiguration from './InstallationConfiguration'
import InstallerFeesAnalyzer from './Advisory/FeesAnalyzer.js'
import UserAccount from '../UserAccount'
import Support from '../Support'

var dashboardCommonJS = require("../../js/dashboardCommon.js");
var generalCommonJS = require("../../js/generalCommon.js")

// DASHBOARD
const Main = (params) => {
  
  const [selectedAppOption, setSelectedAppOption] = useState("")
  const [selectedModalAppOption, setSelectedModalOption] = useState("")

  useEffect(() => {    
    console.log("Estructura principal de la aplicación cargada correctamente.")   

    document.documentElement.setAttribute('style','background:#2B1B76')

    document.getElementById("loaderGeneralAplicacion").className = "loader overlay"
    
    if(localStorage.getItem("installerMode") === null){
      window.location.href = "/"
    }    

    if(params.page === ""){ setSelectedAppOption(<Dashboard seleccionarOpcionMenu={seleccionarOpcionMenu}/>) }
    else { seleccionarOpcionMenu("opcionMenu"+params.page) }

  }, [])

  function gestionarVisibilidadMenuPrincipal(event){   

    if (event.target.id === "cuentaRegresivaAvatar"){      
      if (!document.documentElement.className.includes("menu-open")) { document.documentElement.className = "menu-open" }
      else {document.documentElement.className = ""}
    }
    else if(event.target.id !== "menuPrincipal") {
      if(event.target.id.includes("opcionMenu")){
        document.documentElement.className = ""    
        seleccionarOpcionMenu(event.target.id.replace("Literal",""))
      }
      else{
        document.documentElement.className = ""
      }
    }     
  
  }; 

  function operarDetalleLateralInstalador(accion){  
    if(accion === "abrir"){
      if(localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")){
        document.getElementById("detalleLateralOpcionInstalador").className = "modal lateral-detail green"
      }
      else{
        document.getElementById("detalleLateralOpcionInstalador").className = "modal lateral-detail day "
      }
      
    }else{

      if(localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")){
        document.getElementById("detalleLateralOpcionInstalador").className = "modal lateral-detail hidden"       
        localStorage.removeItem("lastDashboardData") 
      }
      else{
        document.getElementById("detalleLateralOpcionInstalador").className = "modal lateral-detail day hidden"
      }
      
    }
    
}

  function gestionarVisibilidadModalDetalle(event){        
    if ( (document.getElementById("detalleLateralOpcionInstalador") !== null) && !document.getElementById("detalleLateralOpcionInstalador").className.includes("hidden") && (event.target.id === "detalleLateralOpcionInstalador") ){
        operarDetalleLateralInstalador("cerrar")             
    }
};  

  document.addEventListener("keydown", (event) => {        
    if (event.key === 'Escape') {            
      document.documentElement.className = "" //Oculto menú principal
      dashboardCommonJS.operarDetalleLateral("cerrar") //Oculto menú detalle lateral      
    }
});  

  function seleccionarOpcionMenu(opcionSeleccionada){

    document.getElementById("opcionMenuDashboard").className = "button secondary list full-width"    
    document.getElementById("opcionMenuRules").className = "button secondary list full-width hidden"
    document.getElementById("liRules").className += " hidden"
    document.getElementById("opcionMenuInstallationActivity").className = "button secondary list full-width"
    document.getElementById("liInstallationActivity").className += " hidden"
    document.getElementById("opcionMenuHeliasAnalytics").className = "button secondary list full-width"
    document.getElementById("liHeliasAnalytics").className += " hidden"
    document.getElementById("opcionMenuAdvisory").className = "button secondary list full-width"
    document.getElementById("liAdvisory").className += " hidden"
    document.getElementById("opcionMenuInstallationConfiguration").className = "button secondary list full-width"    
    document.getElementById("opcionMenuUserAccount").className = "button secondary list full-width"    
    document.getElementById("opcionMenuSupport").className = "button secondary list full-width"    
    document.getElementById("opcionMenuCookies").className = "button secondary list full-width"    
    document.getElementById("opcionMenuLogout").className = "button secondary list full-width"    

    /* Opciones ocultas ya que se entuentran dentro de la navegación del dashboard */
    document.getElementById("liRules").className += " hidden"    
    document.getElementById("liInstallationActivity").className += " hidden"    
    document.getElementById("liHeliasAnalytics").className += " hidden"
    document.getElementById("liHistoricalEconomics").className += " hidden"
    
    try{
      if (opcionSeleccionada === "opcionMenuFeesAnalyzer"){
        console.log("No hago nada al no ser una opción de menú.")
      }
      else if(opcionSeleccionada !== "opcionMenuCookies"){        
        document.getElementById(opcionSeleccionada).className = document.getElementById(opcionSeleccionada).className.replaceAll(" current", "") + " current"
      }      
      else{
        console.log(window.location.pathname)
        document.getElementById("opcionMenu"+window.location.pathname.replaceAll("/","")).className = document.getElementById("opcionMenu"+window.location.pathname.replaceAll("/","")).className.replaceAll(" current", "") + " current"
      }      
    }
    catch(error){console.log(error)} //Para controlar páginas sin opción de menú tipo BillingPlans
    
    if( (opcionSeleccionada !== "opcionMenuCookies") && (opcionSeleccionada !== "opcionMenuRules") && (opcionSeleccionada !== "opcionMenuHeliasAnalytics") && (opcionSeleccionada !== "opcionMenuFeesAnalyzer") ){ 
      window.history.pushState("", "", '/Installer'+opcionSeleccionada.replace("opcionMenu", "").replace("Helias", ""))
      document.getElementById("buscadorInstalaciones").className += " hidden"    
    }   
    
    if(opcionSeleccionada === "opcionMenuDashboard"){ 
      document.title = "HELIAS Instalador - Cuadro de mando"
      setSelectedAppOption(<Dashboard seleccionarOpcionMenu={seleccionarOpcionMenu}/>) 
    }  
    else if(opcionSeleccionada === "opcionMenuFeesAnalyzer"){ 
      document.getElementById("loaderGeneralAplicacion").className = "loader hidden"
      document.title = "HELIAS Instalador - Analizador 12 facturas"
      setSelectedAppOption(<InstallerFeesAnalyzer/>)
    }    
    else if(opcionSeleccionada === "opcionMenuInstallationConfiguration"){ 
      document.title = "HELIAS Instalador - Configuración"
      setSelectedAppOption(<InstallationConfiguration selectedOption={params.selectedOption}/>) 
    }    
    else if(opcionSeleccionada === "opcionMenuUserAccount"){ 
      document.title = "HELIAS Instalador - Cuenta de usuario"
      setSelectedAppOption(<UserAccount/>) 
    }
    else if(opcionSeleccionada === "opcionMenuSupport"){ 
      document.title = "HELIAS Instalador - Soporte"
      setSelectedAppOption(<Support/>) 
    }
    else if(opcionSeleccionada === "opcionMenuCookies"){ 
      try{                
        generalCommonJS.mostrarPrivacidad()
      }
      catch(error){console.log(error)}
    }
    else if(opcionSeleccionada === "opcionMenuLogout"){ 
      document.title = "HELIAS Instalador - Salir"
      window.location="/Logout" 
    }

  }

  return (    
    <main id="mainDiv" className="installer" onMouseDown={gestionarVisibilidadMenuPrincipal} >      
      
      <MainHeaderHELIAS/>
      
      {selectedAppOption}      
      
      <aside id="detalleLateralPantallaCompleta" className="modal lateral-detail hidden" onMouseDown={gestionarVisibilidadModalDetalle}></aside>

      <aside id="detalleLateralOpcionInstalador" className="modal lateral-detail hidden" onMouseDown={gestionarVisibilidadModalDetalle}>
        <div className="modal-content full-width">

          <button className="link close" onClick={() => operarDetalleLateralInstalador("cerrar")}><span className="material-icon">highlight_off</span></button>

          {selectedModalAppOption}

        </div>
      </aside>

      <FooterHELIAS/>     

    </main>
  )
}

export default Main